/**
 * Session Manager
 *
 * Generates and persists unique session IDs for logging traceability.
 * Session IDs persist across page navigation within the same browser tab.
 */

const SESSION_KEY = 'claims_portal_session_id';

/**
 * Gets the current session ID, generating a new one if it doesn't exist.
 * Uses crypto.randomUUID() for high entropy unique identifiers.
 *
 * @returns {string} The session ID (UUID format)
 */
export function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
}

/**
 * Clears the current session ID from storage.
 * Should be called on logout to start a fresh session on next login.
 */
export function clearSessionId(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
